import { ConsultAgreeItem, ConsultAgreeListItemDescription } from '@/types';

export const SEQ_STAGES = [
  'CHOOSE_BUILDING_TYPE',
  'CHOOSE_PYUNG',
  'CHOOSE_SPACE_STATUS',
  'CHOOSE_CONSTRUCTION_CASE',
  'CHOOSE_CONSTRUCTION_BUDGET',
  'CHOOSE_CONSTRUCTION_PERIOD',
  'CHOOSE_CALL_TIME',
  'INPUT_USER_INFO',
];

export const SEQ_CONSULT_CANCEL_CONFIRM_TITLE = `상담 신청을 취소하시겠습니까?`;
export const SEQ_CONSULT_CANCEL_CONFIRM_SUB_TITLE = `작성 중인 내용은 저장되지 않아요`;

export const SEQ_BUILDING_TYPE_DATA = [
  { name: '아파트', value: 'HT_001', id: 1 },
  { name: '빌라', value: 'HT_002', id: 2 },
  { name: '단독주택', value: 'HT_004', id: 4 },
  { name: '오피스텔', value: 'HT_005', id: 5 },
];

export const SEQ_PYUNG_DATA = [
  { name: '10~20평대', value: 'TEN', id: 1 },
  { name: '30평대', value: 'THIRTY', id: 2 },
  { name: '40평대', value: 'FORTY', id: 3 },
  { name: '50평대 이상', value: 'FIFTY', id: 4 },
];

export const SEQ_SPACE_STATUS_DATA = [
  { name: '거주 중 (짐보관 예정)', value: 'ME', id: 1 },
  { name: '현재 공실', value: 'EMPTY', id: 2 },
  { name: '시공 시 공실 예정', value: 'TOBEEMPTY', id: 3 },
  { name: '신축입주', value: 'MOVEIN', id: 4 },
];

export const SEQ_CONSTRUCTION_BUDGET = [
  {
    name: '5백만원 이하',
    value: '500',
    id: 1,
  },
  {
    name: '1천만원 이하',
    value: '1000',
    id: 2,
  },
  {
    name: '2천만원 이하',
    value: '2000',
    id: 3,
  },
  {
    name: '3천만원 이하',
    value: '3000',
    id: 4,
  },
  {
    name: '4천만원 이하',
    value: '4000',
    id: 5,
  },
  {
    name: '5천만원 이하',
    value: '5000',
    id: 6,
  },
  {
    name: '6천만원 이하',
    value: '6000',
    id: 7,
  },
  {
    name: '7천만원 이하',
    value: '7000',
    id: 8,
  },
  {
    name: '1억원 이하',
    value: '10000',
    id: 9,
  },
  {
    name: '아직 미정이에요',
    value: '0',
    id: 10,
  },
];

export const SEQ_CONSTRUCTION_CASE_DATA = [
  { name: '키친', value: 'KITCHEN', id: 1 },
  { name: '바스', value: 'BATH', id: 2 },
  { name: '수납', value: 'STORAGE', id: 3 },
  { name: '마루', value: 'FLOOR', id: 4 },
  { name: '중문', value: 'CENTRAL_DOOR', id: 5 },
  { name: '도어', value: 'DOOR', id: 6 },
  { name: '창호', value: 'WINDOW', id: 7 },
  { name: '필름', value: 'FILM', id: 8 },
  { name: '벽지', value: 'WALLPAPER', id: 9 },
  { name: '조명', value: 'LIGHT', id: 10 },
  { name: '타일', value: 'TILE', id: 11 },
];

export const SEQ_CONSTRUCTION_PERIOD_DATA = [
  { name: '1개월 이내', value: 'WIN1M', id: 1 },
  { name: '2개월 이내', value: 'WIN2M', id: 2 },
  { name: '3개월 이내', value: 'WIN3M', id: 3 },
  { name: '3개월 이후', value: 'AFT3M', id: 4 },
];

export const SEQ_CALL_TIME_DATA = [
  { name: '상시', value: 'ALWAYS', id: 1 },
  { name: '아침 (9시 이전)', value: 'EARLY_MORNING', id: 2 },
  { name: '오전 (9시 - 12시)', value: 'MORNING', id: 3 },
  { name: '오후 (12시 - 6시)', value: 'AFTERNOON', id: 4 },
  { name: '저녁 (6시 이후)', value: 'EVENING', id: 5 },
];

const SEQ_CONSULT_AGREE_PRIVACY: ConsultAgreeListItemDescription[] = [
  {
    text: `[개인정보 수집 및 이용 동의]

    상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 수집·이용 하고자합니다.
    내용을 자세히 읽으신 후 동의해주시기 바랍니다.
    이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다.
    단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다.
    그 밖의 사항은 (주)한샘 개인정보처리방침에 따릅니다.
    
    1. 개인정보 수집 및 이용 목적
    · 상담 서비스 이행(상담 신청, 해피콜, 상담 매장 및 영업사원 배정)
    · 제품 상담 및 견적 서비스 제공
    · 제품 설치
    · 고객 상담 서비스 제공
    · 이벤트 참여 안내 및 당첨자 연락, 사은품 배송, 본인 확인

    2. 수집 항목
    · 이름, 휴대폰 번호, 주소
    · 상담에 필요한 현장 공사 정보
    \n`,
    isBold: false,
  },
  {
    text: `3. 보유 및 이용기간
    · 회원 탈퇴 시 까지`,
    isBold: true,
  },
];

const SEQ_CONSULT_AGREE_PROVIDE: ConsultAgreeListItemDescription[] = [
  {
    text: `[개인정보 제3자 제공 동의]

    상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 제3자에게 제공 하고자 합니다.
    내용을 자세히 읽으신 후 동의해주시기 바랍니다.
    이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다.
    단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다.
    그 밖의 사항은 (주)한샘 개인정보처리방침에 따릅니다.
    \n`,
    isBold: false,
  },
  {
    text: `1. 제공 받는 자 : 한샘대리점, 한샘제휴점
    
    2. 제공목적
    · 상담 서비스 이행, 제품 상담 및 견적 서비스 제공
    · 제품 설치
    · 고객 상담 서비스 제공
    \n`,
    isBold: true,
  },
  {
    text: `3. 제공항목
    · 이름, 휴대폰 번호, 주소
    · 상담에 필요한 현장 공사 정보
    \n`,
    isBold: false,
  },
  {
    text: `4. 보유 및 이용기간
    · 회원 탈퇴 시 까지`,
    isBold: true,
  },
];

export const SEQ_CONSULT_AGREE_LIST: ConsultAgreeItem[] = [
  {
    id: 1,
    title: '개인정보 수집 및 이용동의',
    description: SEQ_CONSULT_AGREE_PRIVACY,
    name: 'agreement.privacy',
    checked: false,
  },
  {
    id: 2,
    title: '개인정보 제3자 제공 동의',
    description: SEQ_CONSULT_AGREE_PROVIDE,
    name: 'agreement.provide',
    checked: false,
  },
];

export const CERTIFY_ERROR_MESSAGE = {
  INACCURATE: '인증번호를 정확히 입력해 주세요.',
  TIME_EXPIRED: '인증시간이 만료 되었습니다. 다시 시도해 주세요.',
  EXCEEDED: '인증번호를 더 이상 전송 할 수 없습니다.',
};

export const SEQ_CONSULT_KAKAO_TEMPLATE_CODE = 'AT_20240829154432';
